import React from 'react';
import { OptimizedImage } from '../common';
import { ChevronRight, Target, Users, Lightbulb } from 'lucide-react';


export const ValuesSection: React.FC = () => {
  const missionPillars = [
    {
      icon: Target,
      title: 'Purposeful AI',
      description: 'Every AI system we build has a clear purpose: to solve real problems and create meaningful value for users in their daily lives and work.',
      action: 'Learn More',
      image: '/images/019.purposeful.jpeg',
    },
    {
      icon: Users,
      title: 'Human-Centered',
      description: 'We design AI that enhances human capabilities rather than replacing them, fostering collaboration between humans and machines.',
      action: 'Learn More',
      image: '/images/020.human.centered.jpeg',
    },
    {
      icon: Lightbulb,
      title: 'Ethical',
      description: 'We push the boundaries of what\'s possible with AI while maintaining ethical standards and user trust at the core of our innovation.',
      action: 'Learn More',
      image: '/images/021.ethical.jpeg',
    },
  ];

  return (
    <section className="px-4 md:px-16 py-16 md:py-24 lg:py-28 bg-Color-Scheme-2-Background">
      <div className="container mx-auto">
        <div className="mx-auto mb-12 w-full max-w-4xl text-center md:mb-18 lg:mb-20">
          <h2 className="text-4xl md:text-5xl font-bold font-gabarito text-Color-Scheme-2-Text dark:text-Color-Neutral-Lightest leading-tight mb-6">
            Our <span className="text-[#C97B5A]">Values</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 items-start justify-center gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
          {missionPillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return (
              <div
                key={index}
                className="flex w-full flex-col items-center text-center"
              >
                <div className="mb-6 md:mb-8 w-full aspect-[16/10] rounded-2xl overflow-hidden">
                  {pillar.image ? (
                    <OptimizedImage
                      src={pillar.image} 
                      alt={pillar.title} 
                      className="rounded-2xl"
                      sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                    />
                  ) : (
                    <div className="bg-gradient-to-br from-[#F5E6D3] to-[#E5D5C4] dark:from-[#B06747] dark:to-[#A05A40] flex items-center justify-center h-full">
                      <Icon className="w-20 h-20 text-[#C97B5A] dark:text-[#E5A884]" />
                    </div>
                  )}
                </div>
                <h3 className="mb-3 text-2xl md:text-3xl font-bold font-gabarito text-Color-Scheme-2-Text dark:text-Color-Neutral-Lightest md:mb-4 leading-tight">
                  {pillar.title}
                </h3>
                <p className="text-Color-Scheme-2-Text dark:text-Color-Neutral-Light font-cairo mb-6">
                  {pillar.description}
                </p>
                <button className="flex items-center gap-2 text-Color-Neutral-Darkest dark:text-Color-Neutral-Light hover:text-primary dark:hover:text-primary-light transition-colors font-cairo font-medium">
                  {pillar.action}
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};